<template>
  <div class="row">
    <div class="col-12">
      <card>
        <vue-element-loading
          :active="loading.active"
          :color="loading.color"
          :is-full-screen="false"
          :text="loading.text"
          spinner="bar-fade-scale"/>
        <div>
          <div class="col-sm-12 card">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              style="width: 100%;"
            >
              <!-- Columnas dinámicas -->
              <el-table-column
                v-for="column in tableColumns"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :min-width="column.minWidth"
              />
              <!-- Solo Editar -->
              <el-table-column
                fixed="right"
                label="Actions"
                :min-width="80"
              >
                <template slot-scope="props">
                  <a
                    @click="onEdit(props.row)"
                    class="px-1 btn-info btn-simple btn-link"
                    v-tooltip.top-center="'Editar'"
                  >
                    <i class="fa fa-align-justify"></i>
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </card>
    </div>

    <!-- Diálogo de edición -->
    <el-dialog
      :visible.sync="editing"
      title="Editar Ambiente"
      width="500px"
      :append-to-body="true"
    >
      <form id="edit_form" @submit.prevent="validate">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre"
              placeholder="Nombre del Ambiente"
              v-model="ambiente.name"
              v-validate="modelValidations.name"
              name="name"
              :error="getError('name')"
            />
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Identificador"
              placeholder="Código del Ambiente"
              v-model="ambiente.identifier"
              v-validate="modelValidations.identifier"
              name="identifier"
              :error="getError('identifier')"
            />
          </div>
        </div>
        <div class="text-right mt-3">
          <button
            type="submit"
            class="btn btn-filmker-pink btn-fill btn-sm"
          >
            Guardar Cambios
          </button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import { Dialog, Table, TableColumn } from 'element-ui'
import vueElementLoading from 'vue-element-loading'

export default {
  components: {
    vueElementLoading,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      loading: {
        text: 'Please Wait',
        color: '#222',
        active: false
      },
      tableColumns: [
        { prop: 'name',      label: 'Nombre',minWidth: 150 },
        { prop: 'identifier', label: 'Identificador', minWidth: 150 }
      ],
      tableData: [],
      editing: false,
      ambiente: {
        id: null,
        name: '',
        identifier: ''
      },
      modelValidations: {
        name:       { required: true },
        identifier: { required: true }
      }
    }
  },
  methods: {
    loadAmbientes() {
      this.loading.active = true
      this.axios({
        url: `conexions.php?datos=7`,
        method: 'get',
        headers: { authorization: localStorage.token }
      })
      .then(resp => {
        this.loading.active = false
        this.tableData = resp.data.message
      })
      .catch(() => {
        this.loading.active = false
      })
    },

    validate() {
      this.$validator.validateAll().then(valid => {
        if (valid) this.saveAmbiente()
      })
    },

    getError(field) {
      return this.errors.first(field)
    },

    onEdit(row) {
      this.ambiente = { ...row }
      this.editing = true
    },

    saveAmbiente() {
      this.loading.active = true
      const method = this.ambiente.id ? 'put' : 'post'
      this.axios({
        url: `conexions.php`,
        method,
        data: this.ambiente,
        headers: { authorization: localStorage.token }
      })
      .then(() => {
        this.loading.active = false
        this.editing = false
        this.clearForm()
        this.loadAmbientes()
        swal.fire('Guardado', 'Ambiente actualizado', 'success')
      })
      .catch(err => {
        this.loading.active = false
      })
    },

    clearForm() {
      this.ambiente = { id: null, name: '', identifier: '' }
    }
  },
  created() {
    this.loadAmbientes()
  }
}
</script>

<style>
  #edit_form label { color: #777 !important; }
</style>
